export enum UploadSessionMode {
  DirectMultipart = 'direct-multipart',
  Proxy = 'proxy',
}
